import {BaseTCIApplicationDeleteProvider} from "../tci-tenant-services";
import {
    APPLICATION_SCOPE_TYPES,
    ITCIApplicationDeleteProvider,
    ITCIApplicationDeleteRequest, ITCIApplicationDeleteResponse,
    ITCIApplicationDeploymentProvider, SERVICE_URLS, USER_ROLES
} from "@tci/common";
import {ITenantVPNServiceProvider} from "./tci-vpn-provider.service";
import {Injector} from "@angular/core";
import {Headers, Http} from "@angular/http";
import {NodeDeployProvider} from "../node/services";
import {NgUserService} from "../../ng-shared/ng-services";
import {Observable} from "rxjs";

export class TciTenantBaseDeleteSharedService extends BaseTCIApplicationDeleteProvider implements ITCIApplicationDeleteProvider {

    constructor(private deployerSvc: ITCIApplicationDeploymentProvider, private userSrv: NgUserService, injector: Injector, http: Http) {
        super(injector, http);
    }

    getDeployerService(): ITCIApplicationDeploymentProvider {
        return this.deployerSvc;
    }

    getUserService(): NgUserService {
        return this.userSrv;
    }

    canDeleteApplication(input: ITCIApplicationDeleteRequest): Observable<boolean> {
        // IPAS-15681 - App Delete option is enabled for read only user on app list for Flogo App
        // Dont allow RO user to delete
        // Dont allow onPrem apps to be deleted
        return this.getUserService().getAuthForFunction(APPLICATION_SCOPE_TYPES.APP)
            .map(userPath => userPath && (userPath.role === USER_ROLES.RO))
            .flatMap(isRO => {
                    if (isRO) {
                        return Observable.of(false);
                    } else {
                        return this.getUserService().getUserInfo()
                            .map(userInfo => input.application &&
                                (input.application.onPremise !== undefined) &&
                                !input.application.onPremise);
                                // && input.application.owner === userInfo.userId);
                    }
                }
            );
    }

    deleteApplication(input: ITCIApplicationDeleteRequest): Observable<ITCIApplicationDeleteResponse> {
        const options = {headers: new Headers({"Content-Type": "application/json"}), body: input};
        return this.getHttp().delete(SERVICE_URLS.APPS + "/" + input.appId, options)
            .map(res => res.json())
            .catch(err => {
                let msg = "";
                try {
                    msg = err.json().errorMsg;
                } catch (e) {
                    msg = "Uncaught error";
                }
                return Observable.of(<ITCIApplicationDeleteResponse>{appId: input.appId, success: false, msg});
            })
            .map((res: ITCIApplicationDeleteResponse) => {
                if (res.success) {
                    res.msg = `${input.tenantType.toString()} application deleted`;
                }
                return res;
            });
    }
}
